import dums_logo from "../assets/logos/DUMs Logo.png"
import rubrikLogo from "../assets/logos/rubrik.png"
import comcastLogo from "../assets/logos/comcast_logo_icon_170338.png"

// One entry per company, most recent first. Each company holds its `roles`
// (most recent first), rendered as sub-boxes inside the company block.
// Keep each role skimmable: an optional one-line `summary`, 2-4 short
// `highlights` (lead with the outcome; metrics like "50%" or "1100ms to 120ms"
// are auto-bolded by ExperienceList), and a few `tags` for the skills/tech.
const ExperienceCardData = [
    {
        company: "Rubrik",
        logo: rubrikLogo,
        location: "Palo Alto, CA",
        roles: [
            {
                job_title: "Software Engineer II",
                timeline: "May 2026 - Present",
                summary: "Building the agentic platform that helps teams across Rubrik operate faster.",
                highlights: [
                    "Co-own Rubrik's core agent orchestrator",
                    "Build the components that give agents their reach: context engines, authentication systems, and multi-step compositions",
                    "Took the platform from concept to production, now infrastructure teams rely on to automate real work",
                ],
                tags: ["AI Agents", "Generative AI", "Platform Engineering"],
            },
            {
                job_title: "Software Engineer",
                timeline: "July 2024 - May 2026",
                summary: "Developer Experience, GenAI: applied generative AI to boost developer productivity.",
                highlights: [
                    "Built automatic triage bots to streamline development workflows",
                    "Implemented AI-based code reviews",
                ],
                tags: ["Generative AI", "Developer Productivity", "Automation"],
            },
            {
                job_title: "Software Engineer Intern",
                timeline: "May - August 2023",
                summary: "Upgraded the CI orchestrator to unblock a company-wide migration to a modern pull-request workflow.",
                highlights: [
                    "Moved code review from Phabricator to GitHub Pull Requests, including internal verification systems",
                ],
                tags: ["CI/CD", "DevOps", "Developer Tooling"],
            },
        ],
    },
    {
        company: "Duke Motorsports (FSAE)",
        logo: dums_logo,
        location: "Durham, NC",
        roles: [
            {
                job_title: "Lead Electrical Engineer",
                timeline: "May 2023 - May 2024",
                summary: "Led 8 engineers through the design, integration, and testing of the car's electrical and communication systems.",
                highlights: [
                    "Redesigned CAN configurations, cutting bus load from 80% to 40%",
                    "Designed a shift control strategy, cutting average shift time from 1100ms to 120ms",
                    "Implemented a drag reduction system (DRS), cutting lap times by 1.3%",
                    "Built a digital steering wheel with a custom PCB, encoding 17 driver inputs over CAN",
                ],
                tags: ["Embedded Systems", "CAN Bus", "Team Leadership"],
            },
            {
                job_title: "Electrical Engineer",
                timeline: "August 2022 - May 2023",
                highlights: [
                    "Engineered a dyno wiring harness that cut overhead time between system test iterations",
                    "Designed PCBs in Altium for vehicle failsafes",
                    "Configured CAN communication between the ECU, PDM, and dash display to reprioritize sensor I/O",
                ],
                tags: ["PCB Design", "Altium", "Wiring Harnesses"],
            },
        ],
    },
    {
        company: "Comcast",
        logo: comcastLogo,
        location: "Philadelphia, PA",
        roles: [
            {
                job_title: "Product Management Intern",
                timeline: "May - August 2022",
                summary: "Helped launch VideoAI and streamlined product documentation.",
                highlights: [
                    "Wrote Python packages that enrich video content with contextual metadata for the VideoAI launch",
                    "Created new product-requirements templates and guidelines, cutting time in product meetings and sprint updates by 50%",
                ],
                tags: ["Python", "Product Management", "Video AI"],
            },
        ],
    },
]

export default ExperienceCardData
